import React, { useState, useEffect } from 'react'
import { useUpdateEffect } from 'genesis-suite/hooks'
import produce from 'immer'
import { v1 as uuid } from 'uuid'
import { moduleService } from '../../lib/services'
import ModuleSelector from './ModuleSelector'
import EditableList from '../EditableList'
import { roleOptions } from './roleOptions'

const ModuleSecurityController = ({ context, defaultRows, onChange }) => {
    const [rows, setRows] = useState(defaultRows)
    const [modules, setModules] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        let cancelCall = () => {}
        moduleService
            .getAll(context, true, false, cancel => {
                cancelCall = cancel
            })
            .then(allModules => {
                setModules(allModules.map(m => ({ value: m.name, label: m.title })))
                setLoading(false)
            })
            .catch(err => {
                if (err.__CANCEL__) return
                setLoading(false)
                console.error(err)
            })

        return () => cancelCall()
    }, [context])

    useUpdateEffect(() => {
        onChange(rows)
    }, [rows])

    const handleRowRemove = i =>
        setRows(
            produce(rows, draft => {
                draft.splice(i, 1)
            })
        )
    const handleRowAdd = () => setRows([...rows, { id: uuid() }])
    const handleChange = (val, id, type) => {
        if (type === 'module') {
            /* eslint-disable no-unused-vars */
            setRows(
                produce(rows, draft => {
                    draft = draft.map(row => {
                        if (row.id === id) row.node = val
                        return row
                    })
                })
            )
        } else {
            setRows(
                produce(rows, draft => {
                    draft = draft.map(row => {
                        if (row.id === id) row.role = val
                        return row
                    })
                })
            )
        }
    }

    return (
        <EditableList onRemove={handleRowRemove} onAdd={handleRowAdd}>
            {rows &&
                rows.map(row => (
                    <ModuleSelector
                        id={row.id}
                        key={row.id}
                        onChange={handleChange}
                        defaultModule={row.node}
                        defaultRole={roleOptions.find(role => role.value === row.role)}
                        moduleOptions={modules}
                        roleOptions={roleOptions}
                        loading={loading}
                    />
                ))}
        </EditableList>
    )
}

export default ModuleSecurityController
